import server from '../../server'

// Thin wrappers around the persisted draft-order (cart) API.
//
// The draft order is saved server-side so it follows the user across logout,
// cache clearing and switching devices. The shared `server` axios instance
// already attaches the Bearer token on every request. All endpoints operate on
// the authenticated user's single draft (`/draftOrders/me`), so no id is passed.

// Fetch the current user's saved cart. Returns an array of line items.
export const getDraftOrder = async () => {
  const response = await server.get('/draftOrders/me')
  return Array.isArray(response?.data?.items) ? response.data.items : []
}

// Replace the current user's cart. Only { productId, quantity } is persisted;
// the server rehydrates full product details from the catalogue on read, so we
// never store (or send) a stale price/limit snapshot.
export const saveDraftOrder = async (items) => {
  const payload = (Array.isArray(items) ? items : [])
    .map((item) => ({
      productId: item?.productId != null ? item.productId : item?.id,
      quantity: item?.quantity,
    }))
    .filter((item) => item.productId != null && item.quantity != null)

  const response = await server.put('/draftOrders/me', { items: payload })
  return Array.isArray(response?.data?.items) ? response.data.items : []
}

// Empty the current user's cart (after checkout or an explicit clear).
export const clearDraftOrder = async () => {
  await server.delete('/draftOrders/me')
}
